import { useEffect, useRef } from 'react';

type CallbackFunction = () => void;

export const useOutsideClick = <T extends HTMLElement = HTMLElement>(
  callback: CallbackFunction,
) => {
  const ref = useRef<T>(null);

  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        callback();
      }
    };

    document.addEventListener('click', handleClick);

    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, [callback]);

  return ref;
};
